/* unplugin-vue-components disabled */import { render } from "./dialogBtn.vue?vue&type=template&id=5fc01cb2&scoped=true"
import script from "./dialogBtn.vue?vue&type=script&lang=js"
export * from "./dialogBtn.vue?vue&type=script&lang=js"

import "./dialogBtn.vue?vue&type=style&index=0&id=5fc01cb2&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc01cb2"]])

export default __exports__